<template>
    <div>
        <v-card v-for="product in sortedProducts" :key="product.id" class="d-flex mt-4 z-no-focus" height="65px" @click="showAdditionalProduct(product)">
            <v-auto-img :src="product.imagekey" width="100px" height="65px" max-width="100px" max-height="65px" style="border-bottom-left-radius: inherit; border-top-right-radius: 0" />

            <div class="flex-grow-1 px-2 z-min-width-0">
                <div><b>{{product.name}}</b></div>
                <div style="height: 43px;overflow: hidden" v-safe-html="stripHtml(product.description)"></div>
            </div>
            <div class="d-flex px-2 flex-column">
                <div class="primary--text font-weight-bold text-no-wrap align-self-center">{{getPrice(product)}}</div>
                <div class="align-self-end">
                    <checkout-button
                        @click.native.stop=""
                        v-if="useCheckoutButton"
                        :component="{component: 'zoezi-button', props: {text: $translate(buyButtonText), thin: true}}"
                        :products="[{product_id: product.id, count: 1}]"
                        @showCheckout="showCheckout => { if (!showCheckout) $emit('buy', product)}"
                    />
                    <zoezi-button v-else thin :text="$translate(buyButtonText)" @click.stop="buyButtonClick(product)" />
                </div>
            </div>
        </v-card>

        <product-dialog v-model="showProductDialog" :product="showingProduct" :show-count="false" :useCheckoutButton="useCheckoutButton" v-if="showingProduct" @buy="buyButtonClick(showingProduct)" :buy-button-text="buyButtonText" />
    </div>
</template>

<script>
import {stripHtml, getPriceString} from '../util.js'
import ProductDialog from '../components/ProductDialog.vue'
import ZoeziButton from '../views/Button.vue'
import CheckoutButton from '../views/CheckoutButton.vue'
export default {
    name: 'zoezi-simple-product-list',

    props: {
        products: {},
        buyButtonText: {
            type: String,
            default: 'Buy'
        },
        useCheckoutButton: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ProductDialog,
        ZoeziButton,
        CheckoutButton
    },

    data: () => ({
        showProductDialog: false,
        showingProduct: null
    }),

    methods: {
        showAdditionalProduct(product) {
            this.showingProduct = product;
            this.showProductDialog = true;
        },
        stripHtml(x) {
            return stripHtml(x);
        },
        buyButtonClick(product) {
            this.$emit('buy', product)
        },
        getPrice(product) {
            return getPriceString(product)
        }
    },
    computed: {
        sortedProducts() {
            if (!Array.isArray(this.products)) {
                return [];
            }
            return [...this.products].sort((a, b) => {
                // Priority: onetime > trial > others
                const getPriority = (p) => {
                    if (p.onetime) return 0;
                    if (p.trial) return 1;
                    return 2;
                };

                const aPriority = getPriority(a);
                const bPriority = getPriority(b);

                if (aPriority !== bPriority) {
                    return aPriority - bPriority; 
                }

                return a.name.localeCompare(b.name);
            });
        }
    }
}
</script>
